import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=3d3bf91b&"
import script from "./ExchangeList.vue?vue&type=script&lang=ts&"
export * from "./ExchangeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports